import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';

const CompanySelectionGrid = ({ companies, userCurrentSelection = [], handleSelection }) => {

    console.log("userCurrentSelection", userCurrentSelection);
    return (
        <div className="create-plan-flow-insurance-providers-grid">
            {companies.map((company) => {

                console.log("userCurrentSelection", userCurrentSelection);
                console.log("company.id", company.id);
                console.log("userCurrentSelection === company.id", userCurrentSelection === company.id);

                return (
                    <div className={`create-plan-flow-insurance-providers-grid-item ${userCurrentSelection === company.id ? 'active' : ''} ${Array.isArray(userCurrentSelection) && userCurrentSelection.includes(company.id) ? 'active' : ''}`} onClick={() => handleSelection(company.id)}>
                        {company.id === "9999" ? (
                            <p>Other</p>
                        ) : (
                            <img src={CreateCloudfrontUrl(company.iconUrl)} alt={company.company_name} />
                        )}
                    </div>
                )
            })}
        </div>
    );
};

export default CompanySelectionGrid;